export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1c028c0153764fb6b55c2538b17281fc.jpg"
          alt="Faro Energía hero"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-faro-navy/85 via-faro-navy/75 to-faro-navy-light/80" />
        <div className="absolute inset-0 bg-gradient-to-t from-faro-navy/60 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-faro-teal/20 border border-faro-teal/40 text-faro-teal-light text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-8 animate-fade-in">
          <span className="w-2 h-2 bg-faro-teal rounded-full inline-block" />
          Consultoría energética independiente
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 animate-fade-up" style={{ fontFamily: "'Inter', sans-serif" }}>
          Tu guía en el<br />
          <span className="text-faro-yellow">mercado energético</span>
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-up" style={{ animationDelay: "0.15s" }}>
          Ayudamos a particulares, pymes y comunidades a entender su factura, optimizar sus contratos y reducir sus costes energéticos con claridad, cercanía y transparencia.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-up" style={{ animationDelay: "0.3s" }}>
          <button
            onClick={() => handleScroll("#contacto")}
            className="bg-faro-yellow hover:bg-faro-yellow-light text-faro-navy font-semibold text-base px-8 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg"
          >
            Solicita tu estudio gratuito
          </button>
          <button
            onClick={() => handleScroll("#servicios")}
            className="bg-white/10 hover:bg-white/20 border border-white/40 text-white font-medium text-base px-8 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            Conoce nuestros servicios
          </button>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-16 animate-fade-up" style={{ animationDelay: "0.45s" }}>
          {[
            { icon: "ri-shield-check-line", text: "Asesoramiento independiente" },
            { icon: "ri-user-heart-line", text: "Trato humano y cercano" },
            { icon: "ri-money-euro-circle-line", text: "Sin costes ocultos" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-white/70 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-faro-teal-light`} />
              </div>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-sm" />
        </div>
      </div>
    </section>
  );
}
